import { render } from "./VSATClientTemplate.vue?vue&type=template&id=5cf4c4e4&scoped=true"
import script from "./VSATClientTemplate.vue?vue&type=script&lang=js"
export * from "./VSATClientTemplate.vue?vue&type=script&lang=js"

import "./VSATClientTemplate.vue?vue&type=style&index=0&id=5cf4c4e4&scoped=true&lang=css"

import exportComponent from "C:\\onetap\\onetap\\frontend\\onetapuser\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf4c4e4"]])

export default __exports__